<template>
  <div class="input-wrapper">
    <textarea
      v-if="rows"
      v-bind="$attrs"
      @input="handleInput"
      class="input"
      :rows="rows"
      :value="value"
    />
    <masked-input
      v-else-if="type === 'tel'"
      v-bind="$attrs"
      type="tel"
      class="input"
      :value="value"
      :guide="true"
      :mask="getPhoneMask"
      @input="handleTelInput"
    >
    </masked-input>
    <input v-else v-bind="$attrs" @input="handleInput" class="input" :value="value" :type="type" />
  </div>
</template>

<script>
import { emailRegExp } from './emailRegExp';
import MaskedInput from 'vue-text-mask';
import { fullRuTelMask, shortRuTelMask, shortRuEightMask } from './phone-masks';

export default {
  inheritAttrs: false,
  components: {
    MaskedInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      default: 'text',
      type: String,
    },
    rows: {
      default: null,
      type: Number,
    },
  },
  methods: {
    handleInput(event) {
      const { value } = event.target;
      this.$emit('input', value);

      if (this.type === 'email') {
        const validationMessage = !emailRegExp.test(value)
          ? this.$t('wizard.submit.errors.emailValidation')
          : '';

        event.target.setCustomValidity(validationMessage);
      }
    },
    handleTelInput(value) {
      this.$emit('input', value);
    },
    getPhoneMask(rawValue) {
      // если ввод начали с плюс семь
      if (rawValue.startsWith('+7')) {
        return fullRuTelMask;
        // если ввод начали просто с семерки
      } else if (rawValue.startsWith('7')) {
        return shortRuTelMask;
      } else if (rawValue.startsWith('8') && rawValue.replace(/\D/g, '').length <= 11) {
        return shortRuEightMask;
      }
      // в остальных случаях маски не добавляем
      return false;
    },
  },
};
</script>

<style scoped src="./baseInput.css"></style>
